import { gamePresentationOf } from "@softmax/web-features/coworlds";
import type { CustomPage, CustomPreviewProps } from "./registry";

export function customPreviewFor(
  corpusAddress: string,
): CustomPage<CustomPreviewProps> | undefined {
  if (gamePresentationOf(corpusAddress).preview === "gota") {
    return () => import("../gods-of-the-arena/preview");
  }
}
